export default "__VITE_ASSET__DqU79sfm__"